"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuType = void 0;
exports.MenuType = {
    Product: "productsMenuItem",
    Predefined: "predefined", // use for custom data e.g.: "Service and support" section in the menu
    Market: "marketsMenuItem",
};
